import { makeStyles } from '@material-ui/core/styles';

// Constants for reusability and clarity
export const FORM_CONTROL_WIDTH = 200;

export const useListFilterStyles = makeStyles((theme) => {
  const deleteIconSize = theme.spacing(4);
  return {
    // Main container for filters
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      paddingBottom: theme.spacing(1),
    },
    flexContainer: {
      display: 'flex',
    },
    // Group of filter inputs
    inputsGroup: {
      display: 'flex',
      width: '100%',
      flexWrap: 'wrap',
    },
    // Standard active form control (first row)
    formControl: {
      paddingBottom: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: FORM_CONTROL_WIDTH,
      minWidth: FORM_CONTROL_WIDTH,
      '&:last-child': {
        marginRight: 0,
      },
    },
    // Wider active form control for long inputs (first row)
    formControlLong: {
      width: FORM_CONTROL_WIDTH + deleteIconSize,
    },
    // Removes right margin for added controls to make them the same width
    // as the first row controls
    formControlAdd: {
      marginRight: 0,
    },
    // Extra wide for special cases for added controls
    formControlAddLong: {
      width: FORM_CONTROL_WIDTH * 2 + deleteIconSize + theme.spacing(1),
    },
    // Icon button for deleting filters
    deleteIcon: {
      width: deleteIconSize,
      height: deleteIconSize,
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    // Styles for date pickers
    datePickers: {
      marginTop: 0,
      marginBottom: 0,
      '& > div': {
        paddingRight: 0,
        '& > div': {
          marginLeft: 0,
        },
      },
    },
  };
});

export const useDefaultListFilterStyles = makeStyles((theme) => {
  return {
    form: {
      '& > div': {
        '& > div:last-child': {
          width: theme.spacing(1),
        },
      },
    },
    formControl: {
      width: FORM_CONTROL_WIDTH,
    },
    formControlLong: {
      width: FORM_CONTROL_WIDTH * 2 + theme.spacing(1),
    },
  };
});
